import z from "zod";
import { resumeSchema } from "../resume";
import { createZodDto } from "nestjs-zod/dto";

const downloadSchema = z.object({
  id: z.string(),
  date: z.coerce.date(),
  status: z.boolean(),
  url: z.string(),
});

export const downloadWithResumeSchema = downloadSchema.merge(
  z.object({ resume: resumeSchema.nullable().default(null) }),
);

export class DownloadWIthResume extends createZodDto(downloadWithResumeSchema) {}
